var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHrms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.561768,
    y: 0.5,
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_200_9079",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_200_9079",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAABQ0lEQVRoBe2aMW4CMRBFZ9znFEmRdByBi6BsThDK0EGT0KHUFGyUHGQPkCIVouIQkJphjIgEFGik0Si29F3ser3jr+//vMVKZjq2+xdpmOlRH/t/Y4XeOyFqV2/8kf1xvjyMZKa3Ye7X0jTs8fKVJ3xMflGL8VOfSqJJien5dLCmvm6fJukqejWZvvDaTxcD1T1iAf+NDARAwJkAtpAzQPd0EHBH6BQAAWeA7ukg4I7QKQACzgDd00HAHaFToHoCPFjf6G9xXPueb+LEVbl6AlhA6P4wiIOAIaTQEhAIjdcgDgKGkEJLQCA0XoM4CBhCCi0BgdB4DeIgYAgptAQEQuM1iGcCnaGuzBKhLtGODocmynR43ZUwtenzbtuKyPv10vLestAkn1g5fMRft79DJfEkJD/lWT13JLpt8iGP5ZTH+c0eDlIyusu9TZwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrms);
export default __webpack_public_path__ + "static/media/hrms.c15311e23816642e8cb27daf04355759.svg";
export { ForwardRef as ReactComponent };